import React, { useState } from "react";
import { Input, Select, Btn } from "@/components/UI";
import { Filter, FileDown, RotateCcw } from "lucide-react";
import { previewPdf } from "@/lib/pdfActions";
import { toQuery } from "@/lib/products";
import { TrDateField } from "@/components/common/TrDateField";

function Field({ f, value, onChange, testid }) {
  if (f.type === "select") {
    return (
      <Select label={f.label} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        {f.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </Select>
    );
  }
  if (f.type === "date") return <TrDateField label={f.label} value={value} onChange={onChange} testid={testid} />;
  if (f.type === "checkbox") {
    return (
      <label className="flex items-center gap-2 text-sm text-slate-700 h-[38px] mt-auto">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
        {f.label}
      </label>
    );
  }
  return <Input label={f.label} type={f.type || "text"} value={value} placeholder={f.placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testid} />;
}

// Draft values are applied ONLY when FİLTRELE is pressed.
export function ExplicitFilterBar({ fields, initial, onApply, pdfPath, pdfName, testid = "filter" }) {
  const [draft, setDraft] = useState(initial);
  const [applied, setApplied] = useState(initial);
  const apply = () => { setApplied(draft); onApply(draft); };
  const reset = () => { setDraft(initial); setApplied(initial); onApply(initial); };
  return (
    <form className="flex flex-wrap items-end gap-3 mb-4 p-3 rounded-xl border border-slate-200 bg-white/70" data-testid={`${testid}-bar`}
      onSubmit={(e) => { e.preventDefault(); apply(); }}>
      {fields.map((f) => (
        <div key={f.key} className={f.width || "w-48"}>
          <Field f={f} value={draft[f.key]} onChange={(v) => setDraft({ ...draft, [f.key]: v })} testid={`${testid}-${f.key}`} />
        </div>
      ))}
      <div className="flex gap-2 ml-auto">
        <Btn type="button" variant="secondary" onClick={reset} data-testid={`${testid}-reset`}><RotateCcw size={14} /> Temizle</Btn>
        <Btn type="submit" data-testid={`${testid}-apply`}><Filter size={14} /> FİLTRELE</Btn>
        {pdfPath && (
          <Btn type="button" variant="secondary" onClick={() => previewPdf(`${pdfPath}${toQuery(applied)}`, pdfName)} data-testid={`${testid}-pdf`}>
            <FileDown size={14} /> PDF
          </Btn>
        )}
      </div>
    </form>
  );
}
